export default {
  data () {
    return {
      genders: [],
      maritalStatuses: [],
      grossMonthlyIncomes: [],
      relatives: [],
      sourceInformation: [],
      occupations: [],
      livings: [],
      companyTypes: [],
      majors: [],
      graduateYears: [],

      purchaseItems: [],
      typeOfCollaterals: []
    }
  },
  watch: {
    '$i18n.locale' () {
      this.loadDataOption()
    }
  },
  methods: {
    setGenders () {
      this.genders = [
        { label: this.$t('gender.male'), value: 'Male' },
        { label: this.$t('gender.female'), value: 'Female' }
      ]
    },
    setMaritalStatuses () {
      this.maritalStatuses = [
        { label: this.$t('maritalStatuses.single'), value: 'Single' },
        { label: this.$t('maritalStatuses.divorced'), value: 'Divorced' },
        { label: this.$t('maritalStatuses.married'), value: 'Married' },
        { label: this.$t('maritalStatuses.widowed'), value: 'Widowed' }
      ]
    },
    setGrossMonthlyIncomes () {
      this.grossMonthlyIncomes = [
        { label: '<200', value: '<200' },
        { label: '$200-$250', value: '$200-$250' },
        { label: '$251-$350', value: '$251-$350' },
        { label: '$351-$450', value: '$351-$450' },
        { label: '$451-$600', value: '$451-$600' },
        { label: '$601-$800', value: '$601-$800' },
        { label: '$801-$1200', value: '$801-$1200' },
        { label: '$1201-$1500', value: '$1201-$1500' },
        { label: '$1501-$2500', value: '$1501-$2500' },
        { label: '$2501-$4000', value: '$2501-$4000' },
        { label: '$4000+', value: '$4000+' }
      ]
    },
    setRelatives () {
      this.relatives = [
        { label: this.$t('relative.brother'), value: 'Brother' },
        { label: this.$t('relative.sister'), value: 'Sister' },
        { label: this.$t('relative.father'), value: 'Father' },
        { label: this.$t('relative.mother'), value: 'Mother' },
        { label: this.$t('relative.relatives'), value: 'Relatives' },
        { label: this.$t('relative.other'), value: 'Other' }
      ]
    },
    setSourceInformation () {
      this.sourceInformation = [
        { label: this.$t('sourceOfInfo.friendAndFamily'), value: 'Friend and Family' },
        { label: this.$t('sourceOfInfo.flyer'), value: 'Flyer' },
        { label: this.$t('sourceOfInfo.anotherWebsite'), value: 'Another Website' },
        { label: this.$t('sourceOfInfo.facebook'), value: 'Facebook' },
        { label: this.$t('sourceOfInfo.google'), value: 'Google' },
        { label: this.$t('sourceOfInfo.instagram'), value: 'Instagram' },
        { label: this.$t('sourceOfInfo.tukTukAds'), value: 'Tuk Tuk Ads' },
        { label: this.$t('sourceOfInfo.byMail'), value: 'By Mail' },
        { label: this.$t('sourceOfInfo.other'), value: 'Other' }
      ]
    },
    setOccupations () {
      this.occupations = [
        { label: this.$t('occupations.accountant'), value: 'Accountant' },
        { label: this.$t('occupations.administrator'), value: 'Administrator' },
        { label: this.$t('occupations.assistance'), value: 'Assistance' },
        { label: this.$t('occupations.bankTeller'), value: 'Bank Teller' },
        { label: this.$t('occupations.banker'), value: 'Banker' },
        { label: this.$t('occupations.businessOwner'), value: 'Business Owner' },
        { label: this.$t('occupations.callCenter'), value: 'Call Center' },
        { label: this.$t('occupations.carDriver'), value: 'Car Driver' },
        { label: this.$t('occupations.ceo'), value: 'CEO' },
        { label: this.$t('occupations.chiefOfficer'), value: 'Chief Officer' },
        { label: this.$t('occupations.civilEngineer'), value: 'Civil Engineer' },
        { label: this.$t('occupations.cleaner'), value: 'Cleaner' },
        { label: this.$t('occupations.constructionWorker'), value: 'Construction Worker' },
        { label: this.$t('occupations.consultant'), value: 'Consultant' },
        { label: this.$t('occupations.creditOfficer'), value: 'Credit Officer' },
        { label: this.$t('occupations.dentist'), value: 'Dentist' },
        { label: this.$t('occupations.designer'), value: 'Designer' },
        { label: this.$t('occupations.doctor'), value: 'Doctor' },
        { label: this.$t('occupations.electrician'), value: 'Electrician' },
        { label: this.$t('occupations.employee'), value: 'Employee' },
        { label: this.$t('occupations.executive'), value: 'Executive' },
        { label: this.$t('occupations.factoryWorker'), value: 'Factory Worker' },
        { label: this.$t('occupations.filmMaker'), value: 'Film Maker' },
        { label: this.$t('occupations.finance'), value: 'Finance' },
        { label: this.$t('occupations.freelancer'), value: 'Freelancer' },
        { label: this.$t('occupations.frontDesk'), value: 'Front Desk' },
        { label: this.$t('occupations.governmentEmployees'), value: 'Government Employees' },
        { label: this.$t('occupations.head'), value: 'Head' },
        { label: this.$t('occupations.insuranceConsultant'), value: 'Insurance Consultant' },
        { label: this.$t('occupations.it'), value: 'IT' },
        { label: this.$t('occupations.journalism'), value: 'Journalism' },
        { label: this.$t('occupations.lawyer'), value: 'Lawyer' },
        { label: this.$t('occupations.loanCollector'), value: 'Loan Collector' },
        { label: this.$t('occupations.logistic'), value: 'Logistic' },
        { label: this.$t('occupations.manager'), value: 'Manager' },
        { label: this.$t('occupations.marketing'), value: 'Marketing' },
        { label: this.$t('occupations.musician'), value: 'Musician' },
        { label: this.$t('occupations.nurse'), value: 'Nurse' },
        { label: this.$t('occupations.onlineSeller'), value: 'Online Seller' },
        { label: this.$t('occupations.operator'), value: 'Operator' },
        { label: this.$t('occupations.policeOfficer'), value: 'Police Officer' },
        { label: this.$t('occupations.realEstateAgent'), value: 'Real Estate Agent' },
        { label: this.$t('occupations.receptionist'), value: 'Receptionist' },
        { label: this.$t('occupations.relationshipManagement'), value: 'Relationship Management' },
        { label: this.$t('occupations.salesperson'), value: 'Salesperson' },
        { label: this.$t('occupations.securityWorker'), value: 'Security Worker' },
        { label: this.$t('occupations.singer'), value: 'Singer' },
        { label: this.$t('occupations.softwareEngineer'), value: 'Software Engineer' },
        { label: this.$t('occupations.solider'), value: 'Solider' },
        { label: this.$t('occupations.student'), value: 'Student' },
        { label: this.$t('occupations.teacher'), value: 'Teacher' },
        { label: this.$t('occupations.tourGuide'), value: 'Tour Guide' },
        { label: this.$t('occupations.tukTukDriver'), value: 'Tuk Tuk Drivers' }
      ]
    },
    setLiving () {
      this.livings = [
        { label: '<6 months', value: '<6 months' },
        { label: '6 to 12 months', value: '6 to 12 months' },
        { label: '1 to 2 years', value: '1 to 2 years' },
        { label: '2 to 3 years', value: '2 to 3 years' },
        { label: '3 to 5 years', value: '3 to 5 years' },
        { label: '5 to 10 years', value: '5 to 10 years' },
        { label: '10+ years', value: '10+ years' }
      ]
    },
    setCompanyTypes () {
      this.companyTypes = [
        { label: this.$t('companyTypes.bank'), value: 'Bank' },
        { label: this.$t('companyTypes.construction'), value: 'Construction - Engineering' },
        { label: this.$t('companyTypes.corporation_owner'), value: 'Corporation Owner' },
        { label: this.$t('companyTypes.factory_manufacturing'), value: 'Factory - Manufacturing' },
        { label: this.$t('companyTypes.fintech'), value: 'Fintech' },
        { label: this.$t('companyTypes.government'), value: 'Government' },
        { label: this.$t('companyTypes.import_trading'), value: 'Import - Export - Trading' },
        { label: this.$t('companyTypes.insurance'), value: 'Insurance' },
        { label: this.$t('companyTypes.logistic_delivery'), value: 'Logistic - Delivery' },
        { label: this.$t('companyTypes.malls_supermarket'), value: 'Malls - Supermarket' },
        { label: this.$t('companyTypes.media'), value: 'Media' },
        { label: this.$t('companyTypes.medical_hospital'), value: 'Medical - Hospital' },
        { label: this.$t('companyTypes.micro_finance'), value: 'Micro Finance' },
        { label: this.$t('companyTypes.music_entertainment'), value: 'Music - Entertainment' },
        { label: this.$t('companyTypes.ngo'), value: 'NGO' },
        { label: this.$t('companyTypes.restaurant'), value: 'Restaurant' },
        { label: this.$t('companyTypes.retail_shop'), value: 'Retail-Shop' },
        { label: this.$t('companyTypes.small_business_owner'), value: 'Small Business Owner' },
        { label: this.$t('companyTypes.technology'), value: 'Technology' }
      ]
    },
    setMajors () {
      this.majors = [
        { label: this.$t('majors.accounting'), value: 'Accounting' },
        { label: this.$t('majors.aerospaceEngineering'), value: 'Aerospace Engineering' },
        { label: this.$t('majors.agriculture'), value: 'Agriculture' },
        { label: this.$t('majors.architecture'), value: 'Architecture' },
        { label: this.$t('majors.artHistory'), value: 'Art History' },
        { label: this.$t('majors.biology'), value: 'Biology' },
        { label: this.$t('majors.businessManagement'), value: 'Business Management' },
        { label: this.$t('majors.chemicalEngineering'), value: 'Chemical Engineering' },
        { label: this.$t('majors.chemistry'), value: 'Chemistry' },
        { label: this.$t('majors.chinese'), value: 'Chinese' },
        { label: this.$t('majors.civilEngineering'), value: 'Civil Engineering' },
        { label: this.$t('majors.communications'), value: 'Communications' },
        { label: this.$t('majors.computerEngineering'), value: 'Computer Engineering' },
        { label: this.$t('majors.computerScience'), value: 'Computer Science' },
        { label: this.$t('majors.construction'), value: 'Construction' },
        { label: this.$t('majors.criminalJustice/Law'), value: 'Criminal Justice/Law' },
        { label: this.$t('majors.economics'), value: 'Economics' },
        { label: this.$t('majors.education'), value: 'Education' },
        { label: this.$t('majors.electricalEngineering'), value: 'Electrical Engineering' },
        { label: this.$t('majors.english'), value: 'English' },
        { label: this.$t('majors.film'), value: 'Film' },
        { label: this.$t('majors.finance'), value: 'Finance' },
        { label: this.$t('majors.graphicDesign'), value: 'Graphic Design' },
        { label: this.$t('majors.hospitality'), value: 'Hospitality' },
        { label: this.$t('majors.industrialEngineering'), value: 'Industrial Engineering' },
        { label: this.$t('majors.informationTechnology'), value: 'Information Technology' },
        { label: this.$t('majors.interiorDesign'), value: 'Interior Design' },
        { label: this.$t('majors.internationalRelations'), value: 'International Relations' },
        { label: this.$t('majors.journalism'), value: 'Journalism' },
        { label: this.$t('majors.managementInformationSystem'), value: 'Management Information System' },
        { label: this.$t('majors.marketing'), value: 'Marketing' },
        { label: this.$t('majors.math'), value: 'Math' },
        { label: this.$t('majors.mechanicalEngineering'), value: 'Mechanical Engineering' },
        { label: this.$t('majors.medical'), value: 'Medical' },
        { label: this.$t('majors.music'), value: 'Music' },
        { label: this.$t('majors.nursing'), value: 'Nursing' },
        { label: this.$t('majors.philosophy'), value: 'Philosophy' },
        { label: this.$t('majors.physicianAssistant'), value: 'Physician Assistant' },
        { label: this.$t('majors.physics'), value: 'Physics' },
        { label: this.$t('majors.politicalScience'), value: 'Political Science' },
        { label: this.$t('majors.psychology'), value: 'Psychology' },
        { label: this.$t('majors.religion'), value: 'Religion' },
        { label: this.$t('majors.sociology'), value: 'Sociology' }
      ]
    },
    setGraduateYears () {
      const start = 1980
      this.graduateYears.push(start)
      const now = this.$moment(new Date()).format('YYYY')
      for (let i = 1; i <= now - start; i++) {
        this.graduateYears.push(parseInt(start.toString()) + parseInt(i.toString()))
      }
    },
    setPurchaseItems () {
      this.purchaseItems = [
        { label_km: 'គ្រឿងអេឡិចត្រូនិច - ឧបករណ៍ប្រើប្រាស់', label_en: 'Electronic - Appliances', value: 'Electronic - Appliances', id: 'e-appliances' },
        { label_km: 'គ្រឿងអេឡិចត្រូនិច - ទូរស័ព្ទ', label_en: 'Electronic - Phone', value: 'Electronic - Phone', id: 'e-phone' },
        { label_km: 'គ្រឿងអេឡិចត្រូនិច - ថេប្លេត', label_en: 'Electronic - Tablet', value: 'Electronic - Tablet', id: 'e-tablet' },
        { label_km: 'គ្រឿងអេឡិចត្រូនិច - កុំព្យូទ័រ', label_en: 'Electronic - Computer', value: 'Electronic - Computer', id: 'e-computer' },
        { label_km: 'យានយន្ត - រថយន្ត', label_en: 'Auto - Car', value: 'Auto - Car', id: 'a-car' },
        { label_km: 'យានយន្ត - ម៉ូតូ', label_en: 'Auto - Motorcycle', value: 'Auto - Motorcycle', id: 'a-moto' },
        { label_km: 'អចលនទ្រព្យ - ដី', label_en: 'Real Estate - Land', value: 'Real Estate - Land', id: 're-land' },
        { label_km: 'ផ្សេងទៀត', label_en: 'Other', value: 'Other', id: 'Other' }
      ]
    },
    setTypeOfCollaterals () {
      this.typeOfCollaterals = [
        { label_km: 'ប័ណ្ណបើកបររថយន្ត', label_en: 'Car Identification', value: 'Car Identification', id: 'car_id' },
        { label_km: 'ប័ណ្ណបើកបរម៉ូតូ', label_en: 'Motorcycle Identification Card', value: 'Motorcycle Identification Card', id: 'motorcycle_id' },
        { label_km: 'ប័ណ្ណកម្មសិទ្ធិដីធ្លីឬប្លង់ផ្ទះ', label_en: 'Land Title or Home Title', value: 'Land Title or Home Title', id: 'land_home_title' },
        { label_km: 'មូលប្បទានប័ត្រធនាគារ', label_en: 'Bank Cheque', value: 'Bank Cheque', id: 'bank_cheque' },
        { label_km: 'កុំព្យូទ័រ', label_en: 'Computer', value: 'Computer', id: 'computer' },
        { label_km: 'ទូរស័ព្ទ', label_en: 'Phone', value: 'Phone', id: 'Phone' },
        { label_km: 'ផ្សេងទៀត', label_en: 'Other', value: 'Other', id: 'Other' }
      ]
    },
    loadDataOption () {
      this.setGenders()
      this.setMaritalStatuses()
      this.setOccupations()
      this.setRelatives()
      this.setGrossMonthlyIncomes()
      this.setSourceInformation()
      this.setLiving()
      this.setCompanyTypes()
      this.setMajors()
      this.setGraduateYears()
      this.setPurchaseItems()
      this.setTypeOfCollaterals()
    }
  },
  mounted () {
    this.loadDataOption()
  }
}
